import { z } from 'zod';

export const HubSpotPipeline = z.object({
  id: z.string().default(''),
  name: z.string().default(''),
  enabled: z.boolean().default(true),
  useBIResultByDefault: z.boolean().default(false),
  createdAt: z.string().default(''),
  updatedAt: z.string().default(''),
});
export type HubSpotPipelineType = z.infer<typeof HubSpotPipeline>;
